import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'confirmacao.dialog',
  template:`
    <div class="body">

      <div mat-dialog-content>
        <label>{{confirmacao}}</label> <br/>

      </div>
      <div mat-dialog-actions>
        <button  mat-raised-button  title="Sim" color="primary" (click)="sim()">Sim</button>
        <button  mat-raised-button  title="Não"  color="secundary" (click)="nao()" >Não </button>
      </div>
    </div>
  `,
})
export class ConfirmacaoDialog {
    public confirmacao: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmacaoDialog>,
    @Inject(MAT_DIALOG_DATA) public mensagem: string) {
      this.confirmacao = mensagem;
    }


  sim(): void {
      this.dialogRef.close(true);
  }

  nao(): void {
      this.dialogRef.close(false);
    }


}
